export const STATUS = {
  // Completed states
  COMPLETE: 'complete',
  QUALIFIED: 'qualified',

  // In-progress states
  IN_PROGRESS: 'in_progress',
  PENDING: 'pending',
  REGISTERED: 'registered',
  ATTENDING: 'attending',
  SUBMITTED: 'submitted',
  IN_REVIEW: 'in_review',
  RETURNED: 'returned',

  // Locked/Failed states
  LOCKED: 'locked',
  DENIED: 'denied',
  FAILED: 'failed',

  // Other states
  EXPIRED: 'expired',
  READY: 'ready',
}

export const STATUS_CATEGORIES = {
  COMPLETE: [STATUS.COMPLETE, STATUS.QUALIFIED],

  IN_PROGRESS: [
    STATUS.IN_PROGRESS,
    STATUS.PENDING,
    STATUS.REGISTERED,
    STATUS.ATTENDING,
    STATUS.SUBMITTED,
    STATUS.IN_REVIEW,
    STATUS.RETURNED,
  ],

  LOCKED: [STATUS.LOCKED, STATUS.DENIED, STATUS.FAILED],

  READY: [STATUS.READY, STATUS.EXPIRED],
}

// Priority order for aggregating multiple statuses
// Higher index = higher priority
export const STATUS_PRIORITY = [
  STATUS.LOCKED,
  STATUS.DENIED,
  STATUS.FAILED,
  STATUS.READY,
  STATUS.EXPIRED,
  STATUS.RETURNED,
  STATUS.IN_PROGRESS,
  STATUS.PENDING,
  STATUS.SUBMITTED,
  STATUS.IN_REVIEW,
  STATUS.REGISTERED,
  STATUS.ATTENDING,
  STATUS.QUALIFIED,
  STATUS.COMPLETE,
]
